import React, { forwardRef, memo, useMemo } from 'react';
import { SvgIcon } from '@material-ui/core';

import { generateSvgId } from 'src/lib/svg';

export const IconFacebook = memo(
  forwardRef((props, ref) => {
    const svgId = useMemo(() => generateSvgId(), []);

    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 20 20"
        data-fill-none
      >
        <circle
          cx="10"
          cy="10"
          r="10"
        />
        <g clipPath={`url(#&{svgId})`}>
          <path
            d="M18 10.0489C18 14.0664 15.0744 17.3963 11.25 18V12.3755H13.1141L13.4688 10.0489H11.25V8.53909C11.25 7.90241 11.56 7.28208 12.5538 7.28208H13.5625V5.3013C13.5625 5.3013 12.6469 5.1441 11.7716 5.1441C9.94438 5.1441 8.75 6.25837 8.75 8.27562V10.0489H6.71875V12.3755H8.75V18C4.92563 17.3963 2 14.0664 2 10.0489C2 5.60376 5.58187 2 10 2C14.4181 2 18 5.60376 18 10.0489Z"
            fill="#1877F2"
          />
          <path
            d="M13.1141 12.3125L13.4688 10H11.25V8.49934C11.25 7.86669 11.5599 7.25 12.5537 7.25H13.5625V5.28125C13.5625 5.28125 12.647 5.125 11.7717 5.125C9.94434 5.125 8.75 6.2325 8.75 8.2375V10H6.71875V12.3125H8.75V17.9028C9.15731 17.9667 9.57475 18 10 18C10.4252 18 10.8427 17.9667 11.25 17.9028V12.3125H13.1141Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id={svgId}>
            <rect
              width="16"
              height="16"
              transform="translate(2 2)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
